import React from "react";
import { createRoot } from "react-dom/client";
import VideoOnScroll from "../components/VideoOnScroll.js";

const videoRoots = new WeakMap();

const renderVideoOnScroll = ($, $context = $(document)) => {
	const videoContainers = $context
		.find(".js-video-on-scroll-block")
		.addBack(".js-video-on-scroll-block")
		.toArray();

	videoContainers.forEach((videoContainer) => {
		const props = {
			...videoContainer.dataset,
		};
		let root = videoRoots.get(videoContainer);

		if (!root) {
			root = createRoot(videoContainer);
			videoRoots.set(videoContainer, root);
		}

		root.render(<VideoOnScroll {...props} />);
	});
};

export default renderVideoOnScroll;
